import { AfterViewInit, Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BaseComponent } from '../../../base-components/base.component';

@Component({
    selector: 'mvm-tab',
    templateUrl: './mvm-tab.template.html'
})
export class MVMTabComponent extends BaseComponent implements OnInit, AfterViewInit {
    @Input('data') data: any[];
    @Input('contentTemplate') contentTemplate: TemplateRef<any>;
    @Input('selectedTab') selectedTab = 0;

    public ctx = { showType: undefined };
    public selectedMenuItem: any;

    constructor() {
        super();
    }

    ngOnInit() {
        if (this.data && this.data.length > 0) {
            if (this.selectedTab != undefined && this.selectedTab < this.data.length && this.selectedTab >= 0) {
                this.data.sort(this.sortData);
                this.selectedMenuItem = this.data[this.selectedTab];
            } else {
                this.error(`Set value of selectedTab: ${this.selectedTab} was not compatible with the available data.  First data Item was selected.`);
                this.selectedMenuItem = this.data.find((x) => x.order == 0);
            }

            this.showContentForTab();

        } else {
            this.error(`mvm-tab failed to build.  Input values: \n data: ${this.data} `);
        }
    }

    ngAfterViewInit() {}

    showContentForTab() {
        this.ctx.showType = this.selectedMenuItem.showType;
    }

    setSelected(item: any) {
        this.selectedMenuItem = item;
        this.showContentForTab();
    }

    isSelected(item: any) {
        return item === this.selectedMenuItem;
    }

    error(errorMessage: string) {
        console.error(errorMessage);
    }

    sortData(a, b) {
        if (a.order > b.order) {
            return 1;
        } else if (a.order < b.order) {
            return -1;
        } else {
            return 0;
        }
    }
}
